import React from 'react';

import type { RedirectRoute } from '@config/routes';
import { Route } from 'react-router-dom';
import { Redirect } from '@lib/router/components';

const renderRedirects = (redirects: RedirectRoute[]) => {
    return redirects.map(redirect => (
        <Route path={redirect.from} key={redirect.name} element={<Redirect to={redirect.to} />} />
    ));
};

export { renderRedirects };
